import { render, staticRenderFns } from "./modalConfirmarOs.vue?vue&type=template&id=c26701f4&scoped=true"
import script from "./modalConfirmarOs.vue?vue&type=script&lang=js"
export * from "./modalConfirmarOs.vue?vue&type=script&lang=js"
import style0 from "./modalConfirmarOs.vue?vue&type=style&index=0&id=c26701f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26701f4",
  null
  
)

export default component.exports